import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { registerUser } from "../../actions/authActions";
import classnames from "classnames";
import Navbar from "../layout/Navbar";

class Register extends Component {
  constructor() {
    super();
    this.state = {
      name: "",
      email: "",
      password: "",
      password2: "",
      tou: "",
      errors: {},
    };
  }

  componentDidMount() {
    // If logged in and user navigates to Register page, should redirect them to dashboard
    if (this.props.auth.isAuthenticated) {
      this.props.history.push("/");
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.errors) {
      this.setState({
        errors: nextProps.errors,
      });
    }
  }
  onChange = (e) => {
    this.setState({ [e.target.id]: e.target.value });
  };
  onSubmit = (e) => {
    e.preventDefault();
    const newUser = {
      name: this.state.name,
      email: this.state.email,
      password: this.state.password,
      password2: this.state.password2,
      tou: this.state.tou,
    };
    this.props.registerUser(newUser, this.props.history);
  };
  render() {
    const { errors } = this.state;
    return (
      <div className="container">
        <div style={{ marginTop: 20 }}>
          <Navbar />
          <div>
            <div>
              <h4>Sign Up</h4>
            </div>
            <div className="shadow-sm p-3 mb-2 bg-white rounded">
              <p className="grey-text text-darken-1 login-text">
                Already have an account? <Link to="/login">Login</Link>
              </p>
              <form noValidate onSubmit={this.onSubmit}>
                <div className="form-group">
                  <input
                    onChange={this.onChange}
                    value={this.state.name}
                    error={errors.name}
                    id="name"
                    type="text"
                    placeholder="Full Name"
                    className={classnames("form-control", {
                      invalid: errors.name,
                    })}
                  />
                  <span className="red-text">{errors.name}</span>
                </div>
                <div className="form-group">
                  <input
                    onChange={this.onChange}
                    value={this.state.email}
                    error={errors.email}
                    id="email"
                    type="email"
                    placeholder="Email"
                    className={classnames("form-control", {
                      invalid: errors.email,
                    })}
                  />

                  <span className="red-text">{errors.email}</span>
                </div>
                <div className="form-group">
                  <input
                    onChange={this.onChange}
                    value={this.state.password}
                    error={errors.password}
                    id="password"
                    type="password"
                    placeholder="Password"
                    className={classnames("form-control", {
                      invalid: errors.password,
                    })}
                  />

                  <span className="red-text">{errors.password}</span>
                </div>
                <div className="form-group">
                  <input
                    onChange={this.onChange}
                    value={this.state.password2}
                    error={errors.password2}
                    id="password2"
                    type="password"
                    placeholder="Confirm Password"
                    className={classnames("form-control", {
                      invalid: errors.password2,
                    })}
                  />
                  <span className="red-text">{errors.password2}</span>
                </div>
                <div className="form-group">
                  <input
                    className=""
                    onChange={this.onChange}
                    value={this.state.tou}
                    error={errors.tou}
                    type="checkbox"
                    name="priorityOptions"
                    id="priorityLow"
                    checked="checked"
                  />
                  <label className="form-check-label">
                    I accept and agree to the{" "}
                    <Link to="/tos" target="_blank">
                      {" "}
                      Term of Use
                    </Link>
                  </label>
                </div>
                <div className="form-group">
                  <button
                    style={{
                      width: "150px",
                      borderRadius: "3px",
                      letterSpacing: "1.5px",
                      marginTop: "1rem",
                    }}
                    type="submit"
                    className="btn btn-primary btn-lg"
                  >
                    Sign up
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
Register.propTypes = {
  registerUser: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors,
});
export default connect(mapStateToProps, { registerUser })(withRouter(Register));
